import React, { FC, useRef } from 'react';
import { useSelector } from 'react-redux';
import * as classnames from 'classnames';

import { fc } from 'i18n';
import { Marker } from './marker';
import { Map } from 'core/react/general/location/Map';
import { devicesStatesMapSelector } from 'core/redux/selectors/devices';

import styles from './styles.module.css';

interface IEntryPassMapProps {
  offset: number;
  uri?: string;
}
const MAP_NAME = 'tep-management-entry-pass';

export const EntryPassMap: FC<IEntryPassMapProps> = ({ offset, uri }) => {
  const devicesStates = useSelector(devicesStatesMapSelector);

  const map = useRef<Map | null>(null);

  const message = uri && devicesStates ? devicesStates[uri]?.message : null;
  const { longitude, latitude, heading } = message || {};
  const coordinates = longitude && latitude ? [longitude, latitude] : null;

  const wrapperClassname = classnames(styles.wrapper, { [styles.outlined]: !coordinates });

  return (
    <div className={wrapperClassname} style={{ height: `calc(100vh - ${offset + 50}px)` }}>
      {coordinates ? (
        //   eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        <Map name={MAP_NAME} ref={map} baseLayer={Map.Layers.ONE} className={styles.map}>
          {/*eslint-disable-next-line @typescript-eslint/ban-ts-ignore*/}
          {/*@ts-ignore*/}
          <Marker mapName={MAP_NAME} uri={uri} heading={heading} coordinates={coordinates} />
        </Map>
      ) : (
        <div className={styles.noContent}>{fc('No Data')}</div>
      )}
    </div>
  );
};
